<template>
  <el-container class="tui-content" style="display: block;">
    <el-row  class="tui-el">
      <el-col :span="8">功能选择</el-col>
      <el-col :span="16"style="text-align: center;width: 40%;">excel上传</el-col>
    </el-row>
    <el-row  class="tui-el"  style="margin-top: 20px;">
      <el-col :span="8">

        <el-select v-model="value"  filterable placeholder="请选择" >
            <el-option
              v-for="item in options"
              :key="item.label"
              :label="item.label"

              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="values"  filterable placeholder="请选择" >
              <el-option
                v-for="item in optionss"
                :key="item.label"
                :label="item.label"

                :value="item.value">
              </el-option>
            </el-select>
           <el-select v-model="valuet"  filterable placeholder="请选择">
               <el-option
                 v-for="item in tt"
                 :key="item.label"
                 :label="item.label"

                 :value="item.value">
               </el-option>
             </el-select>

      </el-col>

      <el-col :span="4" style="text-align: center;">
        <el-upload
            class="upload-demo"
            ref="upload1"
            :action="action()"
            :on-preview="handlePreview"
            :before-upload="beforeUpload"
            :data="uploadData"
            :on-error = "error"
            :on-success="successResave"
            :on-remove="handleRemove"
            :file-list="fileList"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
        </el-upload>

      </el-col>
      <el-col :span="4" style="text-align: center;">
        <el-upload
            class="upload-demo"
            ref="upload"
            :action="actionAll()"
            :on-preview="handlePreview"
            :before-upload="beforeUpload"
            :data="uploadData"
            :on-error = "error"
            :on-success="successResave"
            :on-remove="handleRemove"
            :file-list="fileList"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUploadAll">完全覆盖</el-button>
        </el-upload>

      </el-col>
      <el-button type="primary" @click='down()'>下载</el-button>


    </el-row>
    <el-dialog
      title="完全覆盖验证:请输入验证词"
      :visible.sync="keysDialogVisible"
      width="30%"
      center>
      <input type="text"  class="searchT" v-model="keys"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="keysDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doUpload()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
       return {
        options: [{'label':'笑话','value':32},{'label':'音频','value':52},{'label':'搜图','value':54},{'label':'字','value':70},{'label':'百科','value':86},{'label':'网站','value':90},{'label':'视频','value':91}],
        optionss:[{'label':'入口纯净过滤','value':1},{'label':'出口纯净过滤','value':2},{'label':'纯净回应语句库入','value':3},{'label':'纯净回应语句库出','value':4}],
        delId:'',
        delIndex:'',
        dialogVisible:false,
        value: 52,
        values: 1,
        newName:'',
        imageId: 0,
        list: [],
        search:'',
        page:1,
        uploadData:{},
        file:'',
        fileList:[],
        keys:'',
        keysDialogVisible:false,
        tt:[{'label':'包含','value':1},{'label':'单独','value':2}],
        valuet:1
      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }

    },

	methods:{
    down(){

      window.open('http://120.79.0.150/downexcelgl?t='+this.values+'&type=2&id='+this.value+'&tt='+this.valuet)

    },
    action(){
      return "http://120.79.0.150/upexcelgl"
    },
    actionAll(){
      return "http://120.79.0.150/upexcelglAll"
    },
    doUpload() {
      if(this.keys == 'self'){
        this.$refs.upload.submit();
        let formData = new FormData();
        this.keysDialogVisible = false
      }else{
        this.msg('验证词不正确','error')
        this.keysDialogVisible = false
      }



    },
    submitUploadAll() {
      this.keysDialogVisible = true


    },
    submitUpload() {
      this.$refs.upload1.submit();
      let formData = new FormData();


    },
    handleRemove(file, fileList) {

    },
    handlePreview(file) {

       console.log(file);
     },
     beforeUpload (file) {

        this.uploadData = {type:2,id:this.value,t:this.values,tt:this.valuet};

           let promise = new Promise((resolve) => {
               this.$nextTick(function () {
                   resolve(true);
               });
           });
           return promise;
    },
    //上传成功钩子
    successResave(response, file, fileList){
      console.log(response)
      if(response.code==200){
         alert('上传成功')

      }
    },
    //失败钩子
     error(response, file, fileList){
           console.log(response)
     },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/gnglexcel.vue